import React from 'react'
import moment from 'moment'
import CalendarWeekDay from 'pages/app/vacation/partials/CalendarWeekDay'

function CalendarWeekDays ({ week, startOfWeek = null }) {
  const currentDay = moment(startOfWeek)

  const calendarDays = []

  while (currentDay.isoWeek() === week) {
    calendarDays.push(currentDay.clone())
    currentDay.add(1, 'day')
  }

  return calendarDays.map(day => {
    const formattedDay = day.format('D')

    return (
      <CalendarWeekDay
        key={formattedDay}
        formattedDay={formattedDay}
        isToday={day.isSame(moment(), 'day')}
      />
    )
  })
}

export default React.memo(CalendarWeekDays)
